import type { ThemeConfig } from '../types'
import { tidepoolConfig as generated } from '../../generated/theme-presets'

// Tidepool: NEUBRUTALISM. Thick chunky borders. Hard-offset shadows with zero blur.
// Bold, loud, playful — like a Gumroad checkout page went to summer camp.
// Everything has weight and presence. Shadows punch down-right like rubber stamps.
// 3px borders everywhere. Narrow sidebar, tight content, snappy transitions.
// This theme has opinions and isn't afraid to show them.
export const tidepoolConfig: ThemeConfig = generated
